import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import "../assets/css/footer.css";

// FooterLink shape: { label, href, onClick? }
// FooterSection shape: { title, links: FooterLink[] }

const Footer = () => {
  const navigate = useNavigate();
  const [email, setEmail] = useState("");
  const [showThankYou, setShowThankYou] = useState(false);

  useEffect(() => {
    if (!showThankYou) return;

    const timer = setTimeout(() => {
      setShowThankYou(false);
    }, 3000);

    return () => clearTimeout(timer);
  }, [showThankYou]);
  
  const currentYear = new Date().getFullYear();

  // const scrollToSection = (sectionId: string) => {
  //   const section = document.getElementById(sectionId);

  //   if (section) {
  //     const rect = section.getBoundingClientRect();
  //     const sectionTop = rect.top + window.scrollY;
  //     const sectionBottom = rect.bottom + window.scrollY;
  //     const sectionHeight = sectionBottom - sectionTop;
  //     const screenHeight = window.innerHeight;

  //     // Get the navbar height to account for fixed positioning
  //     const navbar = document.querySelector(".navbar") as HTMLElement;
  //     const navbarHeight = navbar ? navbar.offsetHeight : 0;

  //     let targetScroll: number;

  //     // Special case: always center the story section
  //     if (sectionId === "story") {
  //       const sectionCenter = sectionTop + sectionHeight / 2;
  //       const screenCenter = screenHeight / 2;
  //       targetScroll = sectionCenter - screenCenter;
  //     } else if (sectionHeight < screenHeight) {
  //       // If section fits on screen, center it
  //       const sectionCenter = sectionTop + sectionHeight / 2;
  //       const screenCenter = screenHeight / 2;
  //       targetScroll = sectionCenter - screenCenter;
  //     } else {
  //       // If section is taller than screen, position its start at the top, accounting for navbar
  //       targetScroll = sectionTop - navbarHeight;
  //     }

  //     window.scrollTo({
  //       top: Math.max(0, targetScroll),
  //       behavior: "smooth",
  //     });
  //   }
  // };

  const handleCompanyClick = (sectionId, path) => {
    const currentPath = window.location.pathname;
    const isAboutPage = currentPath === "/about" || currentPath === "/about";

    if (isAboutPage) {
      // Already on about page, just scroll to section by setting hash
      window.location.hash = sectionId;
    } else {
      // Navigate to about page with hash
      navigate(`${path}#${sectionId}`);
    }
  };

  const handleSolutionClick = (sectionId) => {
    // If already on home page, just update the hash directly to trigger hashchange event
    if (
      window.location.pathname === "/" ||
      window.location.pathname === "/" ||
      window.location.pathname === "/"
    ) {
      window.location.hash = sectionId;
    } else {
      // Otherwise navigate to home with the hash
      navigate("/#" + sectionId);
    }
  };

  const footerSections = [
    {
      title: "Company",
      links: [
        {
          label: "About us",
          href: "https://www.traxccel.com/about",
        },
        {
          label: "Our values",
          href: "https://www.traxccel.com/about#values",
        },
        {
          label: "Our story",
          href: "https://www.traxccel.com/about#story",
        },
        {
          label: "Leadership",
          href: "https://www.traxccel.com/about#leadership",
        },
        { label: "Experiences", href: "https://www.traxccel.com/experiences" },
        {
          label: "Locations",
          href: "https://www.traxccel.com/about#locations",
        },
      ],
    },
    {
      title: "Resources",
      links: [
        { label: "axlInsights", href: "https://www.traxccel.com/insights" },
        { label: "Join us", href: "https://www.traxccel.com/join-us" },
      ],
    },
    {
      title: "Services & solutions",
      links: [
        {
          label: "Reimagine2.0",
          href: "https://www.traxccel.com/#Imagine",
        },
        {
          label: "Data foundation",
          href: "https://www.traxccel.com/#Enable:DF",
        },
        {
          label: "Data engineering & platform",
          href: "https://www.traxccel.com/#Enable:DE",
        },
        {
          label: "Business intelligence & analytics",
          href: "https://www.traxccel.com/#Enable:BI",
        },
        {
          label: "Machine learning & predictive analytics",
          href: "https://www.traxccel.com/#traxccel:ml-analytics",
        },
        {
          label: "GenAI & intelligent automation",
          href: "https://www.traxccel.com/#traxccel:ai-security",
        },
        {
          label: "Visual intelligence",
          href: "https://www.traxccel.com/#traxccel:ai-apps",
        },
        {
          label: "AI/MLOps",
          href: "https://www.traxccel.com/#traxccel:gen-ai",
        },
      ],
    },
  ];

  return (
    <footer className="footer">
      <hr className="footer__divider" />
      <div className="footer__container">
        <div className="footer__top">
          <div className="footer__sections">
            <div className="footer__sections-column">
              {footerSections.slice(0, 2).map((section, index) => (
                <div key={index} className="footer__section">
                  <h4 className="footer__section-title">{section.title}</h4>
                  <ul className="footer__links">
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        {link.onClick ? (
                          <button
                            onClick={link.onClick}
                            className="footer__link footer__link-button"
                          >
                            {link.label}
                          </button>
                        ) : (
                          <a
                            href={link.href}
                            className="footer__link footer__link-anchor"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {link.label}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
            <div className="footer__sections-column">
              {footerSections.slice(2).map((section, index) => (
                <div key={index + 2} className="footer__section">
                  <h4 className="footer__section-title">{section.title}</h4>
                  <ul className="footer__links">
                    {section.links.map((link, linkIndex) => (
                      <li key={linkIndex}>
                        {link.onClick ? (
                          <button
                            onClick={link.onClick}
                            className="footer__link footer__link-button"
                          >
                            {link.label}
                          </button>
                        ) : (
                          <a
                            href={link.href}
                            className="footer__link footer__link-anchor"
                            target="_blank"
                            rel="noopener noreferrer"
                          >
                            {link.label}
                          </a>
                        )}
                      </li>
                    ))}
                  </ul>
                </div>
              ))}
            </div>
          </div>

          <div className="footer__newsletter">
            <h4 className="footer__section-title">Stay updated</h4>
            <p className="footer__newsletter-description">
              Subscribe to our newsletter for the latest insights in data + AI
            </p>
            <form
              className="footer__newsletter-form"
              onSubmit={(e) => {
                e.preventDefault();
                if (!email) return;
                setShowThankYou(true);
                setEmail("");
              }}
            >
              <input
                type="email"
                placeholder="Enter your email"
                className="footer__newsletter-input"
                required
                value={email}
                onChange={(e) => {
                  setEmail(e.target.value);
                  if (showThankYou) setShowThankYou(false);
                }}
              />
              <div className="footer__newsletter-button">
                <button type="submit" className="hero__cta_2 footer__button">
                  Subscribe
                </button>
              </div>
            </form>
            {showThankYou && (
              <p className="footer__newsletter-thankyou" aria-live="polite">
                Thank you for subscribing!
              </p>
            )}
          </div>
        </div>

        <div className="footer__bottom">
          <div className="footer__copyright">
            <p className="footer__copyright-text">
              © {currentYear} Traxccel. All rights reserved.
            </p>
            <div className="footer__legal-links">
              <a href="https://www.traxccel.com/privacy-policy" className="footer__legal-link" target="_blank" rel="noopener noreferrer">
                Privacy policy
              </a>
              <span className="footer__legal-separator">•</span>
              <a href="https://www.traxccel.com/terms-of-service" className="footer__legal-link" target="_blank" rel="noopener noreferrer">
                Terms of service
              </a>
              {/* <span className="footer__legal-separator">•</span>
              <a href="/Traxccel-UI/cookie-policy" className="footer__legal-link">
                Cookie policy
              </a> */}
            </div>
          </div>

          <div className="footer__socials">
            <a
              href="https://www.linkedin.com/company/traxccel/?viewAsMember=true"
              className="footer__social-link"
              aria-label="LinkedIn"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M4.98 3.5C4.98 4.88 3.86 6 2.5 6S0 4.88 0 3.5 1.12 1 2.5 1s2.48 1.12 2.48 2.5zM.5 8h4V23h-4V8zm7 0h3.8v2.05h.05c.53-1 1.83-2.05 3.77-2.05 4.03 0 4.77 2.65 4.77 6.1V23h-4v-6.7c0-1.6-.03-3.66-2.23-3.66-2.24 0-2.58 1.74-2.58 3.54V23h-4V8z" />
              </svg>
            </a>
            <a
              href="https://www.facebook.com/profile.php?id=100077089835520&mibextid=ZbWKwL"
              className="footer__social-link"
              aria-label="Facebook"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M22 12.07C22 6.49 17.52 2 12 2S2 6.49 2 12.07c0 5 3.66 9.14 8.44 9.93v-7.02H7.9v-2.91h2.54V9.41c0-2.5 1.49-3.89 3.77-3.89 1.09 0 2.23.2 2.23.2v2.46h-1.26c-1.24 0-1.63.77-1.63 1.56v1.87h2.78l-.44 2.91h-2.34v7.02C18.34 21.21 22 17.07 22 12.07z" />
              </svg>
            </a>
            <a
              href="https://x.com/traxccel?s=09"
              className="footer__social-link"
              aria-label="X"
              target="_blank"
              rel="noopener noreferrer"
            >
              <svg
                width="20"
                height="20"
                viewBox="0 0 24 24"
                fill="currentColor"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24h-6.657l-5.207-6.807-5.974 6.807H2.882l7.73-8.835L1.24 2.25h6.837l4.966 6.59 5.421-6.59zM17.478 20.221h1.833L6.369 3.886H4.418l13.06 16.335z" />
              </svg>
            </a>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
